import { MenuItem } from 'primeng/api';

/**
 * Quick access options for the main layout view.
 */
export const ItemsLayoutMainOptions: MenuItem[] = [
  {
    automationId: 'PR_002',
    label: 'menu_main.products',
    icon: 'pi pi-fw pi-tags',
    routerLink: 'products/list',
    tooltip: 'main_layout.products_description',
  },
  {
    automationId: 'PK_003',
    label: 'menu_main.packing_list',
    icon: 'pi pi-fw pi-box',
    routerLink: 'packings/list',
    tooltip: 'main_layout.packing_list_description',
  },
  {
    automationId: 'PK_004',
    label: 'menu_main.packing_validator',
    icon: 'pi pi-fw pi-clipboard',
    routerLink: 'packings/validator',
    tooltip: 'main_layout.packing_validator_description',
  },
];

/**
 * Array objects for main-sidebar menu.
 * @type {MenuItem[]} Array for objects compatible with menu primeng
 */
export const ItemsMenu: MenuItem[] = [
  {
    automationId: 'PR_000',
    label: 'menu_main.products',
    icon: 'pi pi-fw pi-tags',
    items: [
      {
        automationId: 'PR_002',
        label: 'menu_main.products_list',
        icon: 'pi pi-fw pi-list',
        routerLink: 'products/list',
      },
    ],
  },
  {
    automationId: 'PK_000',
    label: 'menu_main.packings',
    icon: 'pi pi-fw pi-box',
    items: [
      {
        automationId: 'PK_003',
        label: 'menu_main.packing_list_states',
        icon: 'pi pi-fw pi-box',
        routerLink: 'packings/list-states',
      },
      {
        automationId: 'PK_003',
        label: 'menu_main.packing_list',
        icon: 'pi pi-fw pi-list',
        routerLink: 'packings/list',
      },
      {
        automationId: 'PK_004',
        label: 'menu_main.packing_validator',
        icon: 'pi pi-fw pi-clipboard',
        routerLink: 'packings/validator',
      },
    ],
  },

];
